// removed by extract-text-webpack-plugin
module.exports = {"container":"-OdkUpOoJ9iL1y6oQpe8E","buttonCustomStyle":"_1F5emYAuexXDq0kS6c6_nc","buttonContainer":"_3l2um6J67snbFXz9rp8o7O","buttonWrapper":"_2X20VbuDb6tWb5GFLQ87th","customButton":"_1rubqlQIhYbATxZNSumaex"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/realityCheckWarningScreen.css
// module id = 870
// module chunks = 0